var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":"credits-panel"}},[_c('product-creation-title'),_c('product-creation-form'),_c('product-creation-rules')],1)}
var staticRenderFns = []

export { render, staticRenderFns }